<form [formGroup]="recipientsForm">
  <div class="form-group">
    <label class="font-md fw-bold mb-1"
           [translate]="'orderProcess.giftDelivery.recipientsForm.name'">
      Recipients name
    </label>

    <input class="form-control"
           [placeholder]="('common.name' | translate) + '...'"
           [formControlName]="'deliveryUserName'">
  </div>

  <div class="form-group">
    <label class="font-md fw-bold mb-1"
           [translate]="'orderProcess.giftDelivery.recipientsForm.phone'">
      Recipients phone number
    </label>

    <ng-container *ngIf="countryCode">
      <ui-i18n-phone-input
        *libphonenumber
        name="deliveryPhone"
        [formControlName]="'deliveryPhone'"
        [maxlength]="'32'"
        [defaultCountryCode]="countryCode"
        [showLabel]="false"
        [placeholder]="('profile.myAccount.phone' | translate) + '...'"
      ></ui-i18n-phone-input>
    </ng-container>
  </div>

  <div class="form-group">
    <label class="font-md fw-bold mb-1"
           [innerHTML]="'orderProcess.giftDelivery.recipientsForm.email' | translate">
      Recipients email address <span class="text-muted">(optional)</span>
    </label>

    <input class="form-control"
           [placeholder]="('common.emailAddress' | translate) + '...'"
           [formControlName]="'deliveryEmail'">
  </div>

  <div class="form-group write-message-wrap">
    <label class="write-message-label fw-bold mb-1 mb-md-min-3"
           [translate]="'orderProcess.giftDelivery.recipientsForm.message'">
      Write a message to the recipient
    </label>

    <textarea class="form-control" rows="3"
              [placeholder]="('orderProcess.giftDelivery.recipientsForm.messagePlaceholder' | translate) + '...'"
              [formControlName]="'messageToRecipient'"></textarea>
  </div>
</form>
